import Application from 'src/widgets/impact/impact'
window.Application = Application
